import { useAccount, } from 'wagmi';
export function useGlobalWalletSignerAccount(parameters = {}) {
    const account = useAccount(parameters);
    if (!account.addresses?.[1]) {
        return {
            address: undefined,
            addresses: undefined,
            chain: undefined,
            chainId: undefined,
            connector: undefined,
            isConnected: false,
            isReconnecting: false,
            isConnecting: false,
            isDisconnected: true,
            status: 'disconnected',
        };
    }
    return {
        ...account,
        address: account.addresses[1],
    };
}
//# sourceMappingURL=useGlobalWalletSignerAccount.js.map